import { DropdownOption } from 'components/dropdown/component'

import * as Types from './types'

export const AI_NAME = 'AI'

export const LengthDropdownOptions: DropdownOption[] = [
  {key: 'Short (1 or 2 sentences)', value: 30},
  {key: 'Medium (paragraph)', value: 75},
  {key: 'Long (multiple paragraphs)', value: 125},
]

export const LanguageDropdownOptions: DropdownOption[] = [
  {key: 'English', value: 'English'},
  {key: 'British English', value: 'British English'},
  {key: 'Spanish', value: 'Spanish'},
  {key: 'French', value: 'French'},
  {key: 'German', value: 'German'},
  {key: 'Portugese', value: 'Portugese'},
]

export const PromptTypeDropdownOptions: DropdownOption[] = [
  {key: 'Introduction', value: 'Introduction'},
  {key: 'Conclusion', value: 'Conclusion'},
  {key: 'Promotional', value: 'Promotion'},
]

export const FormatTypeOptions: DropdownOption[] = [
  {key: 'Text', value: 'text'},
  {key: 'Lists', value: 'lists'},
  {key: 'Markdown', value: 'markdown'},
  {key: 'HTML', value: 'HTML'},
]

export const EmojiDropdownOptions: DropdownOption[] = [
  {key: 'No Emojis', value: 0},
  {key: 'Use Emojis', value: 1},
  {key: 'More Emojis!', value: 2},
]

export const ToneDropdownOptions: DropdownOption[] = [
  { key: 'Neutral', value: 'neutral' },
  { key: 'Formal', value: 'formal' },
  { key: 'Conversational', value: 'conversational' },
  { key: 'Humorous', value: 'humorous'},
  { key: 'Inspirational', value: 'inspirational' },
]

export const ComplexityDropdownOptions: DropdownOption[] = [
  { key: 'Simple', value: 'simple' },
  { key: 'Intermediate', value: 'intermediate' },
  { key: 'Advanced', value: 'advanced' },
]

export const PerspectiveDropdownOptions: DropdownOption[] = [
  { key: 'Neutral', value: 'neutral' },
  { key: 'First Person', value: 'first_person' },
  { key: 'Second Person', value: 'second_person' },
  { key: 'Third Person', value: 'third_person' },
]

export const CreativityDropdownOptions: DropdownOption[] = [
  { key: 'Neutral', value: 'neutral' },
  { key: 'Imaginative', value: 'imaginative' },
  { key: 'Factual', value: 'factual' },
]

export const ToneDropdownSelector: Types.SelectorType = {
  title: 'Tone',
  options: ToneDropdownOptions,
  key: 'tone',
}

export const LengthDropdownSelector: Types.SelectorType = {
  title: 'Length',
  options: LengthDropdownOptions,
  key: 'length',
}

export const EmojiDropdownSelector: Types.SelectorType = {
  title: 'Emojis',
  options: EmojiDropdownOptions,
  key: 'emoji',
}

export const LanguageDropdownSelector: Types.SelectorType = {
  title: 'Language',
  options: LanguageDropdownOptions,
  key: 'language',
}

export const FormatDropdownSelector: Types.SelectorType = {
  title: 'Format',
  options: FormatTypeOptions,
  key: 'format',
}

export const ComplexityDropdownSelector: Types.SelectorType = {
  title: 'Complexity',
  options: ComplexityDropdownOptions,
  key: 'complexity',
}

export const PerspectiveDropdownSelector: Types.SelectorType = {
  title: 'Perspective',
  options: PerspectiveDropdownOptions,
  key: 'perspective',
}

export const CreativityDropdownSelector: Types.SelectorType = {
  title: 'Creativity',
  options: CreativityDropdownOptions,
  key: 'creativity',
}

export const ALL_SELECTOR_TYPES: Types.SelectorType[] = [
  LengthDropdownSelector,
  ToneDropdownSelector,
  EmojiDropdownSelector,
  LanguageDropdownSelector
]

export enum RecommendationType {
  PERSON = 'person',
  ARTICLE = 'article',
  HELP = 'help'
}